/**
 * Helper compartido — distance enum (backend) → label localizado (i18n).
 *
 * v15.5-§8.3.E: extraído del componente RaceCard (donde vivía como const
 * local) para reutilizarlo desde PromoteRaceModal (que necesita formatear
 * el copy "vas a sustituir {previous} por {next}" con la distance como
 * fallback cuando la race no tiene `name`).
 *
 * Si en futuras carreras necesitamos esta utilidad en otros componentes
 * (e.g. notificaciones, breadcrumbs, summary), centralizar aquí evita
 * tener que sincronizar 3+ copias del mismo Record.
 *
 * Cubre los 8 valores de `ALLOWED_RACE_DISTANCES` del backend. Si el
 * enum no se reconoce, devuelve el valor crudo (defensa, mismo
 * comportamiento que tenía RaceCard).
 */
import { t } from "@/i18n/es";

const DISTANCE_LABEL_KEY: Record<string, keyof typeof t.plan> = {
  "5k": "raceDistance5k",
  "10k": "raceDistance10k",
  "15k": "raceDistance15k",
  "20k": "raceDistance20k",
  "half_marathon": "raceDistanceHalfMarathon",
  "marathon": "raceDistanceMarathon",
  "trail_short": "raceDistanceTrailShort",
  "trail_long": "raceDistanceTrailLong",
};

/** Devuelve el label localizado para un distance enum del backend.
 *  Si el enum no se reconoce, devuelve el valor crudo. */
export function distanceLabel(distance: string): string {
  const key = DISTANCE_LABEL_KEY[distance];
  return key ? t.plan[key] : distance;
}
